import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { Variant } from '../../../../types/ProductTypes';
import { numberWithCommas, allowNumbersOnly } from '../../../../shared/utils';
import TrashIcon from "../../../../assets/icons/ic_delete.svg";
import AddImg from "../../../../assets/add-img.svg";
import DatePicker from "react-datepicker";
import { ProductImagePopUp } from './ProductImagePopUp';
import NotificationPopup from '../NotificationPopup';


interface ProductVarianceModalProps {
    show: boolean;
    onClose: () => void;
    variants: Variant[];
    setVariants: (variant: Variant[]) => void;
    pageProps: any;
    sizeOfFetch: number;
}

const getImagesGallery = async ({ pageProps, payload }: any) => {

    await pageProps.getImageGalleryAction(payload, false);
}

let imagesChosen: any = [];

const ProductVarianceModal = ({ show, onClose, variants, setVariants, pageProps, sizeOfFetch }: ProductVarianceModalProps) => {
    const [filingVariants, setFillingVariants] = useState<Variant[]>(variants);
    const [isEdtting, setIsEditting] = useState<boolean>(false);
    const [editingIndex, setEditingIndex] = useState<null | number>(null);
    const [showImagesModal, setShowImagesModal] = useState<boolean>(false);
    const [catListItems, setCatListItems] = useState<any[]>([]);
    const [showModal, setShowModal] = useState<boolean>(false);
    const [currentVariant, setCurrentVariant] = useState<Variant>({
        category: 'color',
        value: '',
        optionalUnit: undefined,
        stockQuantity: '',
        price: '',
        isTaxable: false,
        addDiscount: false,
        discountPercentage: undefined,
        discountPrice: '',
        discountStartDate: undefined,
        discountEndDate: undefined,
        images: [], // max 3
    });

    const handleAddVariant = (e: any) => {
        e.preventDefault()
        const updatedVariants = [...filingVariants];
        if (filingVariants.some(v => v.value === currentVariant.value && v.category === currentVariant.category && !isEdtting)) {
            setShowModal(true)
            return;
        }

        if (editingIndex !== null) {
            updatedVariants[editingIndex] = currentVariant;
            setEditingIndex(null);
        } else {
            updatedVariants.push(currentVariant);
        }

        setFillingVariants(updatedVariants);
        setCurrentVariant({
            category: 'color',
            value: '',
            optionalUnit: undefined,
            stockQuantity: '',
            price: '',
            isTaxable: false,
            addDiscount: false,
            discountPercentage: undefined,
            discountPrice: '',
            discountStartDate: undefined,
            discountEndDate: undefined,
            images: [], // max 3
        });
        setIsEditting(false)
    };

    const handleEdit = (index: number) => {
        setCurrentVariant(filingVariants[index]);
        setIsEditting(true)
        setEditingIndex(index);
    };
    const handleDelete = (index: number) => {
        const updatedVariants = filingVariants.filter((_, i) => i !== index);
        setFillingVariants(updatedVariants);

        if (editingIndex === index) {
            setCurrentVariant({
                category: 'color',
                value: '',
                optionalUnit: undefined,
                stockQuantity: '',
                price: '',
                isTaxable: false,
                addDiscount: false,
                discountPercentage: undefined,
                discountPrice: '',
                discountStartDate: undefined,
                discountEndDate: undefined,
                images: [], // max 3
            });
            setEditingIndex(null);
        } else if (editingIndex as number > index) {
            setEditingIndex(editingIndex as number - 1);
        }
    };
    const handleUploadImagesUpdate = (newImages: any[]) => {
        setCurrentVariant((prev) => {
            const existingImages = prev.images || [];
            const totalImages = existingImages.length + newImages.length;

            let updatedImages = [...existingImages, ...newImages];

            if (totalImages > 3) {
                const excess = totalImages - 3;
                updatedImages = updatedImages.slice(excess);
            }

            return {
                ...prev,
                images: updatedImages,
            };
        });
    };

    const removeProductImage = (url: any) => {

        let imagesBatch = currentVariant.images;

        imagesBatch = imagesBatch.filter((itemData: any) => {
            return itemData.url !== url;
        });
        setCurrentVariant((prev) => ({
            ...prev,
            images: [],
        }));
        setCurrentVariant((prev) => ({
            ...prev,
            images: [...imagesBatch],
        }));
    }

    const handleInputChange = (e: React.ChangeEvent<any>) => {
        const { name, value, type, checked } = e.target;
        setCurrentVariant(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };
    const handleDiscountInputChange = (name: string, value: string | Date) => {
        setCurrentVariant(prev => ({
            ...prev,
            [name]: value
        }));
    };

    return (
        <Modal show={show} onHide={onClose} centered className="variant-modal" size="xl">
            <Modal.Header closeButton>
                <Modal.Title className='variance-header'>Add a Product Variance</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p className='variance-description'>Add the product variance below. Variance can be by Color, Size, and Count.</p>
                {filingVariants.length > 0 && (
                    <div className="variant-summary">
                        {filingVariants.map((variant, index) => (
                            <div key={index} className="variant-card">
                                <div className="variant-left">
                                    <div>
                                        <div className="variant-label">Variance {index + 1}</div>
                                    </div>
                                    <div className="variant-chip-container">
                                        <div className="variant-chip">{variant.category}: {variant.value}</div>
                                        <div className="variant-chip">Price: ${variant.price}</div>
                                        <div className="variant-chip">Stock Qty: {variant.stockQuantity}</div>
                                    </div>
                                </div>
                                <div className="variant-actions">
                                    <button className="edit-btn" onClick={() => handleEdit(index)}>✎</button>
                                    <button className="delete-btn" onClick={() => handleDelete(index)}>🗑</button>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
                <form className="variant-form" onSubmit={handleAddVariant}>
                    <div className="two-shared-box">
                        <div>
                            <label htmlFor="category" className='tax-label'>
                                Variance
                            </label>
                            <select name="category" value={currentVariant.category} className="input-wrap inapp-input" onChange={(e) => handleInputChange(e)}>
                                <option value="">Select Variance</option>
                                <option value="color">Color</option>
                                <option value="length">Length</option>
                                <option value="weight">Weight</option>
                            </select>
                        </div>
                        <div className="two-shared-box">
                            <div>
                                <label htmlFor="value" className='tax-label'>
                                    Value
                                </label>
                                <input name="value" required placeholder={currentVariant.category === 'color' ? ("E.g. Red") : ("E.g 30")} className='input-wrap inapp-input' value={currentVariant.value} onChange={handleInputChange} />
                            </div>
                            {(currentVariant.category === 'length' || currentVariant.category === 'weight') && (
                                <div>
                                    <label htmlFor="optionalUnit" className='tax-label'>
                                        Unit
                                    </label>
                                    <select name="optionalUnit" value={currentVariant.optionalUnit} className="input-wrap inapp-input" onChange={handleInputChange}>
                                        {currentVariant.category === 'length' ? (
                                            <>
                                                <option value="cm">Centimeters</option>
                                                <option value="m">Meters</option>
                                            </>
                                        ) : (
                                            <>
                                                <option value="g">Grams</option>
                                                <option value="kg">Kilograms</option>
                                                <option value="lbs">Pounds</option>
                                            </>
                                        )}
                                    </select>
                                </div>
                            )}
                        </div>
                    </div>

                    <div className="two-shared-box">
                        <div>
                            <label htmlFor="price" className='tax-label'>
                                Price
                            </label>
                            <div className="price-wrap">
                                <span className="currency-pre">$</span>
                                <input type="number" name="price" placeholder="Price" value={currentVariant.price} required onChange={handleInputChange} className='input-wrap inapp-input' />
                            </div>
                        </div>
                        <div>
                            <label htmlFor="stockQuantitiy" className='tax-label'>
                                Stock Quantity
                            </label>
                            <input type="number" name="stockQuantity" placeholder="Stock Quantity" value={currentVariant.stockQuantity} required onChange={handleInputChange} className='input-wrap inapp-input' />
                        </div>
                    </div>


                    <div className="two-shared-box">
                        <div className="product-images-container">
                            {currentVariant.images.length < 3 &&
                                <div className={(currentVariant.images.length >= 1) ? "image-control" : "image-control full"}>
                                    <div className="images-label">Product image</div>
                                    <div className="product-images" onClick={() => {
                                        let allCatData: any = [];
                                        pageProps.getProductMetaDataRequest.request_data.response.categories.forEach((eachCat: any) => {
                                            allCatData.push({
                                                value: eachCat.name,
                                                label: eachCat.name
                                            })
                                        })
                                        imagesChosen.length = 1;
                                        setCatListItems(allCatData)
                                        let payload = `page=1&size=${sizeOfFetch}`;
                                        getImagesGallery({ pageProps, payload })

                                        setShowImagesModal(true)
                                    }}>
                                        <div className="upload-wrap-content">
                                            <img src={AddImg} alt="" />
                                            <div className="upload-txt">Upload images (3 Max)</div>
                                        </div>

                                    </div>
                                </div>
                            }
                            {
                                (currentVariant.images.length >= 1) &&
                                <div className="all-images-chosen">
                                    {
                                        currentVariant.images.map((eachImage: any, index: any) => {

                                            return (
                                                <div className="product-image-wrap" key={index}>
                                                    <div className="image-actions">
                                                        <div className="select-cover">
                                                            <input type="radio" name="cover-image-select" />
                                                        </div>
                                                        <div className="deleteicon" onClick={() => removeProductImage(eachImage.url)}>
                                                            <img src={TrashIcon} alt="" className="" />
                                                        </div>
                                                    </div>
                                                    <div className="product-image-item"
                                                        key={index}
                                                    >
                                                        <img src={eachImage.url} alt="" />
                                                    </div>
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            }
                        </div>
                        <div className='discount-taxable-box'>
                            <div className="checkbox-radio-wrap">
                                <label>
                                    <input type="checkbox" name="isTaxable" checked={currentVariant.isTaxable} onChange={handleInputChange} />
                                    Is this product taxable?
                                </label>
                            </div>
                            <div className="checkbox-radio-wrap">
                                <label>
                                    <input type="checkbox" name="addDiscount" checked={currentVariant.addDiscount} onChange={handleInputChange} />
                                    Add a discount
                                </label>
                            </div>
                            {currentVariant.addDiscount &&
                                <div className="discount-wrap">
                                    <div className="two-shared-box">
                                        <div className="form-group">
                                            <div>
                                                <label htmlFor="discountPercentage">
                                                    Discount %
                                                </label>
                                                <input
                                                    disabled={!currentVariant.price}
                                                    required
                                                    value={allowNumbersOnly(currentVariant.discountPercentage as any, 3) ?? ''}
                                                    name="discountPercentage"
                                                    type="number"
                                                    placeholder="Discount %"
                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                                        let valueSet: any = numberWithCommas(e.target.value)
                                                        if (parseFloat(valueSet) <= 100 || e.target.value === "") {
                                                            handleDiscountInputChange("discountPercentage", valueSet)

                                                            let originalPrice: any = parseFloat((currentVariant.price ?? '').toString().replace(/,/g, ''));
                                                            valueSet = valueSet.replace(/,/g, '');

                                                            let newProductPrice: any = parseFloat(valueSet) / 100 * parseFloat(originalPrice);
                                                            newProductPrice = parseFloat(originalPrice) - newProductPrice;
                                                            newProductPrice = Number.parseFloat(newProductPrice.toString()).toFixed(2);

                                                            handleDiscountInputChange("discountPrice", newProductPrice.toString())
                                                        }
                                                    }}
                                                    className="input-wrap inapp-input"
                                                />

                                            </div>

                                        </div>
                                        <div className="form-group">
                                            <div>
                                                <label htmlFor="productDiscountPrice">
                                                    New price
                                                </label>

                                                <div className="price-wrap">
                                                    <span className="currency-pre">$</span>
                                                    <input
                                                        value={numberWithCommas(currentVariant.discountPrice as any)}
                                                        name="productDiscountPrice"
                                                        type="text"
                                                        disabled={!currentVariant.price}
                                                        required
                                                        onChange={(e: any) => {

                                                            let valueSet: any = numberWithCommas(e.target.value)
                                                            handleDiscountInputChange("discountPrice", valueSet)

                                                            if (parseFloat(valueSet) >= parseFloat(currentVariant.price as string)) {
                                                                handleDiscountInputChange("discountPercentage", "")

                                                            } else {
                                                                let originalPrice: any = parseFloat((currentVariant.price ?? '').toString().replace(/,/g, ''));
                                                                valueSet = valueSet.replace(/,/g, '');

                                                                let diff = parseFloat(originalPrice) - parseFloat(valueSet),
                                                                    perCentOffer = Math.round((diff / parseFloat(originalPrice)) * 100);
                                                                handleDiscountInputChange("discountPercentage", perCentOffer.toString())
                                                            }
                                                        }}
                                                        className="input-wrap inapp-input"
                                                    />

                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                    <div className="two-shared-box">
                                        <div className="form-group">
                                            <div>
                                                <label htmlFor="discountStartDate">
                                                    Start date
                                                </label>

                                                <DatePicker
                                                    selected={currentVariant.discountStartDate}
                                                    showIcon={true}
                                                    className='input-wrap inapp-input'
                                                    required
                                                    onChange={(date: Date) => {
                                                        handleDiscountInputChange("discountStartDate", date)
                                                    }}
                                                    minDate={new Date()}
                                                    name="discountStartDate"
                                                    placeholderText="Select start date"
                                                />
                                            </div>

                                        </div>
                                        <div className="form-group">
                                            <div>
                                                <label htmlFor="discountEndDate">
                                                    End date
                                                </label>
                                                <DatePicker
                                                    showIcon={true}
                                                    required
                                                    className='input-wrap inapp-input'
                                                    selected={currentVariant.discountEndDate}
                                                    onChange={(date: Date) => {
                                                        handleDiscountInputChange("discountEndDate", date)
                                                    }}
                                                    name="discountEndDate"

                                                    minDate={new Date()}
                                                    placeholderText="Select end date"
                                                />

                                            </div>

                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>

                    <button className="add-another" type='submit'>+ {isEdtting ? ("Save New Changes") : ("Add Another Variant")}</button>
                </form>

                <div className="product-cta">
                    <Button variant="success" className="add-main" disabled={filingVariants.length === 0 || isEdtting} onClick={() => {
                        setVariants(filingVariants)
                        onClose();
                    }}>Add Variance</Button>
                </div>
            </Modal.Body>
            {showImagesModal && <ProductImagePopUp
                pageProps={pageProps}
                showImagesModal={showImagesModal}
                uploadImagesData={currentVariant.images}
                setUploadImagesData={handleUploadImagesUpdate}
                catListItems={catListItems}
                hideProductImgModal={() => setShowImagesModal(false)}
            />}
            {showModal &&
                <NotificationPopup message='A variant with the same value and category already exists.' isOpen={showModal} onClose={() => setShowModal(false)} />
            }
        </Modal >
    );
};


export default ProductVarianceModal;
